import { useMutation, useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { getMyProfile, updateMyProfile } from '../services/user';
import { useTokens } from './auth/useTokens';

export const useMyProfile = () => {
  const pathname = usePathname();
  const { accessToken } = useTokens.getState();
  return useQuery({
    queryKey: ['my-profile'],
    queryFn: getMyProfile,
    enabled:
      !pathname.startsWith('/sso') &&
      !pathname.startsWith('/disclaimer') &&
      !!accessToken,
    retry: false,
  });
};

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: updateMyProfile,
  });
};
